// (function () {
//     'use strict';

//     const module = angular.module('imApp');

//     module.component('productMoveChoice', {
//         templateUrl: 'views/components/views/productMoveChoice/productMoveChoice.template.html?v=' + module.version,
//         controllerAs: 'vm',
//         controller: ['$stateParams', 'stateService', 'modalService', 'translateService', 'productMoveChoiceService', function ($stateParams, stateService, modalService, translateService, productMoveChoiceService) {

//             // #region VARIABLES & DEFINITIONS

//             const vm = this;
//             let prodId = $stateParams.prod_id;
//             let compKeyno = $stateParams.comp_keyno;

//             let translations = {
//             	error: '',
//             	ok: ''
//             };

//             vm.model = {
//                 edit: {},
//                 selectListMoveTo: [],
//                 lockedSave: false
//             };

//             // #endregion VARIABLES & DEFINITIONS

//             // #region TRANSLATION FUNCTION

//             async function translate() {
//                 let data = await translateService.translateBatch(translations);

//                 Object.keys(translations).forEach((key) => {
//                     if (data?.[key]) translations[key] = data[key];
//                 });
//             }

//             // #endregion TRANSLATION FUNCTION

//             // #region LOAD PROCEDURE FUNCTION CALLS

//             async function loadEdit() {
//                 vm.model.edit = (await productMoveChoiceService.getProductMoveChoice({
//                     prod_id: prodId,
//                     comp_keyno: compKeyno
//                 }))[0];
//             }

//             async function loadMoveTo() {
//                 return vm.model.selectListMoveTo = await productMoveChoiceService.listMoveTo(vm.model.edit);
//             }

//             // #endregion LOAD PROCEDURE FUNCTION CALLS

//             // #region BUTTON SAVE PROCEDURE FUNCTION CALL

//             vm.saveChanges = function () {
//                 vm.model.lockedSave = true;

//                 productMoveChoiceService.saveObj(vm.model.edit).then(function (response) {
//                     if (response[0].errorcode !== '0') {
//                         modalService.show({
//                             type: 'warning',
//                             title: translations.error,
//                             message: response[0].errormessage,
//                             buttons: [{
//                                 label: translations.ok,
//                                 cssClass: 'btn-warning',
//                                 action: function (dialogItself) {
//                                     dialogItself.close();
//                                     vm.model.lockedSave = false;
//                                 }
//                             }]
//                         });
//                     } else {
//                         vm.model.lockedSave = false;
//                         stateService.back();
//                     }
//                 });
//             }

//             // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

//             // #region ON INIT FUNCTION

//             vm.$onInit = async function () {
//                 translate();
//                 await loadEdit();
//                 loadMoveTo();
//             }

//             // #endregion ON INIT FUNCTION

//         }]
//     });
// })();
